import { useIntersectionObserverAsync } from "designSystem/hooks";
import { FlexColumn } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { Children, FunctionComponent, PropsWithChildren, ReactElement, useRef } from "react";

export interface FlexInfiniteLoaderProps extends PropsWithChildren {
	/** indicates there are more results to show in the flex container */
	hasMoreResults: boolean;

	/** callback to load more results */
	onMoreResults: () => Promise<void>;

	/** skeleton to show for indication of "loading more" */
	SkeletonComponent: ReactElement;
}

const FlexInfiniteLoader: FunctionComponent<FlexInfiniteLoaderProps> = observer((props) => {
	const {
		children,
		hasMoreResults,
		onMoreResults,
		SkeletonComponent,
	} = props;
	const childrenWithSkeleton = Children.toArray(children);
	const ref = useRef<HTMLDivElement>(null);

	useIntersectionObserverAsync(ref, {
		freezeOnceVisible: false,
		onIntersection: hasMoreResults ? onMoreResults : null,
		threshold: 0.5,
	});

	childrenWithSkeleton.push((
		<div key="FlexInfiniteLoader_Skeleton" ref={ref}>
			{SkeletonComponent}
		</div>
	));

	return (
		<FlexColumn>
			{hasMoreResults ? childrenWithSkeleton : children}
		</FlexColumn>
	);
});

export default FlexInfiniteLoader;